import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StatusTagComponent } from './status-tag.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconNameToDefinitionModule } from 'libraries/pipes/icon-name-to-definition/icon-name-to-definition.module';

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
    ],
    declarations: [
        StatusTagComponent,
    ],
    exports: [
        StatusTagComponent,
    ],
})
export class StatusTagModule {}